// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__sSpV7","title":"Chip_title__pXWjh"};